import type { WikiTopic } from "../types.js";
import { earningsReaction } from "./earnings-reaction.js";
import { exDateAvoid } from "./ex-date-avoid.js";
import { rank } from "./rank.js";
import { technical } from "./technical.js";

/** The producers that run once at the close and name a position, in registry order. */
export const positionStrategies: readonly WikiTopic[] = [
  rank,
  technical,
  earningsReaction,
  exDateAvoid,
];
